import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const ROLES = {
  ADMIN: "admin",
  DOCTOR: "doctor",
  PATIENT: "patient",
  LAB: "lab",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // starts true — guards wait for this

  useEffect(() => {
    // Restore session from localStorage on mount
    const stored = localStorage.getItem("hc_user");
    if (stored) {
      try {
        setUser(JSON.parse(stored));
      } catch {
        localStorage.removeItem("hc_user");
      }
    }
    setLoading(false); // only set false AFTER we've checked storage
  }, []);

  const login = (userData, token) => {
    const session = { ...userData, token };
    localStorage.setItem("hc_user", JSON.stringify(session)); // sync — saved before navigate
    setUser(session);
  };

  const logout = () => {
    localStorage.removeItem("hc_user");
    setUser(null);
  };

  const isRole = (role) => user?.role === role;

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}